import { render, staticRenderFns } from "./OptionsCardSkeleton.vue?vue&type=template&id=b3a47bae"
var script = {}
import style0 from "./OptionsCardSkeleton.vue?vue&type=style&index=0&id=b3a47bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports